// pages/ResetPasswordPage.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import NewForgotPasswordForm from './NewForgotPassword';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPasswordPage = () => {
  const query = useQuery();
  const token = query.get('token');

  if (!token) {
    return <p>Token invalide ou manquant.</p>;
  }

  return <NewForgotPasswordForm token={token} />;
};

export default ResetPasswordPage;
